import { render, staticRenderFns } from "./BranchStatsPanel.vue?vue&type=template&id=71c18158&scoped=true&"
import script from "./BranchStatsPanel.vue?vue&type=script&lang=js&"
export * from "./BranchStatsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c18158",
  null
  
)

export default component.exports